import React, { useState, useRef } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';

interface MobileSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string | React.ReactNode;
}

export const MobileSidebar: React.FC<MobileSidebarProps> = ({ isOpen, onClose, children, title }) => {
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.touches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    if (!touchStart) return;
    const currentTouch = e.touches[0].clientX;
    const diff = touchStart - currentTouch;

    // If swiping left (closing gesture)
    if (diff > 50) {
      onClose();
      setTouchStart(null);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex md:hidden touch-none">
      <div
        ref={sidebarRef}
        className="w-64 bg-dark-surface border-r border-dark-border/30 shadow-2xl flex flex-col animate-in slide-in-from-left duration-200"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
      >
        <div className="p-3 bg-dark-header border-b border-dark-border/30 flex justify-between items-center shrink-0">
          <div className="flex items-center">
            {typeof title === 'string' ? (
              <span className="text-xs font-bold text-white uppercase tracking-wider">{title}</span>
            ) : (
              title
            )}
          </div>
          <Button
            variant="ghost"
            size="xs"
            onClick={onClose}
            data-testid='unknown-close-btn'
            data-ux='close'
            data-interaction-id='unknown-close-btn'><X size={14}/></Button>
        </div>
        <div className="flex-1 overflow-y-auto flex flex-col">
          {children}
        </div>
        <div className="p-2 text-center text-dark-muted text-[10px] shrink-0">
          &larr; Swipe left to close
        </div>
      </div>
      <div className="flex-1 bg-black/50 animate-in fade-in duration-200" onClick={onClose} />
    </div>
  );
};
